module.exports = __webpack_public_path__ + "static/img/success.377dc4a7.png";